import { Space, List } from "antd";
import { Link } from "react-router-dom";
import { getIssueStatusLabel } from "helpers/options/issue_statuses";
import { EditOutlined } from "@ant-design/icons";

const Item = ({ id, identifier, status }) => (
  <List.Item>
    <List.Item.Meta
      title={
        <Space size={2}>
          {getIssueStatusLabel(status)}
          <Link to={`/issues/${id}`}>
            {identifier} <EditOutlined />
          </Link>
        </Space>
      }
    />
  </List.Item>
);

export default Item;
